/*global jQuery, window */
(function($) {
	'use strict';

	$(function() {
	
	  $('[data-toggle="tooltip"]').tooltip();

	  var attivaModal = function(message, buttons, idButtons, callBack) {
	    $('.modal-body p').hide();
	    $('.modal-body p').html(message);
	    $('.modal-body p').show();

	    if (!$('.modal').hasClass('in')) {
	      $('.modal').modal('show');
	    }

	    $('.modal-footer').html('');

	    if (typeof buttons !== 'undefined' && buttons !== null) {
	      if (buttons.length > 0) {
	        $.each(buttons, function(index, value) {
	          if (idButtons[index] === '') {
	            $('.modal-footer').append('<button type="button" class="btn btn-default" data-dismiss="modal">' + value + '</button>');
	          } else {
	            $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
	          }
	        });
	      }
	    }
	    if (typeof callBack === 'function') {
	      callBack();
	    }
	  };


	  $('.copiadati').on('click', function(){
	  	var fromStep = $(this).data('fromstep');
	  	var toStep = $(this).data('tostep');

  		$('#' + toStep + '_nome').val($('#' + fromStep + '_nome').val());
			$('#' + toStep + '_cognome').val($('#' + fromStep + '_cognome').val());
			$('#' + toStep + '_ruolo').val($('#' + fromStep + '_ruolo').val());
			$('#' + toStep + '_email').val($('#' + fromStep + '_email').val());
			$('#' + toStep + '_telefono').val($('#' + fromStep + '_telefono').val());
			$('#' + toStep + '_check_commercial').val($('#' + fromStep + '_check_commercial').val());
	  
	  });

	  
	  jQuery.validator.addMethod("cfvalido", function(value, element) {
      
      var piva = $('#step_2_p_iva').val();
      var cf = value.toUpperCase();

      if (piva === '' && cf === '') {
      	return false;
      	/*
        var cfReg = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
        if (!cfReg.test(cf))

          return false;

        var set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
        var s = 0;
        for( var i = 1; i <= 13; i += 2 )
          s += setpari.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));

        for( var i = 0; i <= 14; i += 2 )
          s += setdisp.indexOf( set2.charAt( set1.indexOf( cf.charAt(i) )));

        if ( s%26 != cf.charCodeAt(15)-'A'.charCodeAt(0) ) {
          return false;
        }
        */
      }

			return true;

   	}, "Inserire un codice fiscale valido");



	  var setRiepilogo = function(step, next) {

	  	var ret = false;
			var validatorStep = $('#form-associarsi').validate({
  		 	//debug: true,
  		 	//ignore: [],
	      focusInvalid: false,
	      onkeyup: false,
	      onfocusout: false,
	      errorElement: 'p',
	      errorPlacement: function(error) {
	        var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
	        '<h4>' + $(error).html() + '</h4><br>';
	        attivaModal(tmpl, ['Chiudi'], ['']);
	      },
	      rules: {
	      	tiposocio: {required: true },
	        step_2_rag_soc: {required: true },
	        step_2_indirizzo: {required: true },
	        step_2_citta: {required: true },
	        step_2_provincia: {required: true },
	        step_2_cap: {required: true },
	        step_2_nome_socio: {required: false },
	        step_2_website: {required: true },
	        step_2_attivita_principale: {required: true },
	        step_2_p_iva: {
            required: function(){
                if ($('#step_2_cod_fis').val() === '') {
                  return true;
                }
              return false;
            }
          },
          step_2_cod_fis: {
            required: function(){
              if ($('#step_2_p_iva').val() === '') {
                  return true;
                }
              return false;
            }/*,
          	cfvalido : function(){
              return !($('#step_2_cod_fis').val() === '');
          	}*/
          },
	        step_2_telefono: {required: true },

	        step_3_nome: {required: true },
	        step_3_cognome: {required: true },
	        step_3_ruolo: {required: true },
	        step_3_email: {required: true, email: true },
	        step_3_telefono: {required: true },
	        step_3_check_commercial: {required: true },

	        step_4_nome: {required: true },
	        step_4_cognome: {required: true },
	        step_4_ruolo: {required: true },
	        step_4_email: {required: true, email: true },
	        step_4_telefono: {required: true },
	        step_4_check_commercial: {required: true },

	        step_5_nome: {required: true },
	        step_5_cognome: {required: true },
	        step_5_ruolo: {required: true },
	        step_5_email: {required: true, email: true },
	        step_5_telefono: {required: true },
	        step_5_check_commercial: {required: true },

	        step_6_presidente_check_commercial: { required: function(){ if ($('#step_6_presidente_cognome').val() !== '') { return true;} return false;}},
					step_6_amministratore_delegato_check_commercial: { required: function(){ if ($('#step_6_amministratore_delegato_cognome').val() !== '') { return true;} return false;}},
					step_6_direttore_generale_check_commercial: { required: function(){ if ($('#step_6_direttore_generale_cognome').val() !== '') { return true;} return false;}},
					step_6_direttore_finanziario_check_commercial: { required: function(){ if ($('#step_6_direttore_finanziario_cognome').val() !== '') { return true;} return false;}},
					step_6_direttore_risorse_umane_check_commercial: { required: function(){ if ($('#step_6_direttore_risorse_umane_cognome').val() !== '') { return true;} return false;}},
					step_6_direttore_marketing_check_commercial: { required: function(){ if ($('#step_6_direttore_marketing_cognome').val() !== '') { return true;} return false;}},
					step_6_direttore_relest_comunicazioni_check_commercial: { required: function(){ if ($('#step_6_direttore_relest_comunicazioni_cognome').val() !== '') { return true;} return false;}},
					step_6_direttore_relist_publicaffair_check_commercial: { required: function(){ if ($('#step_6_direttore_relist_publicaffair_cognome').val() !== '') { return true;} return false;}},
					step_6_partner_check_commercial: { required: function(){ if ($('#step_6_partner_cognome').val() !== '') { return true;} return false;}},
					step_6_managing_partner_check_commercial: { required: function(){ if ($('#step_6_managing_partner_cognome').val() !== '') { return true;} return false;}},
					step_6_associate_check_commercial: { required: function(){ if ($('#step_6_associate_cognome').val() !== '') { return true;} return false;}},
					step_6_general_counsel_check_commercial: { required: function(){ if ($('#step_6_general_counsel_cognome').val() !== '') { return true;} return false;}},

					step_7_motivo: {required: true },
	        step_7_tramite: {required: true },

	        step_8_nome: {required: true },
	        step_8_cognome: {required: true },
	        step_8_ruolo: {required: true },
	        step_8_email: {required: true, email: true },
	        step_8_telefono: {required: true },
	        step_8_check_commercial: {required: true },

	        step_9_check_privacy: {required: true },
	        step_9_check_statuto: {required: true },
	      },
	      messages: {
	      	tiposocio: {required: setup.texts.testi['err_step_1_tiposocio'] },
	        step_2_rag_soc: {required: setup.texts.testi['err_step_2_rag_soc'] },
	        step_2_indirizzo: {required: setup.texts.testi['err_step_2_indirizzo'] },
	        step_2_citta: {required: setup.texts.testi['err_step_2_citta'] },
	        step_2_provincia: {required: setup.texts.testi['err_step_2_provincia'] },
	        step_2_cap: {required: setup.texts.testi['err_step_2_cap'] },
	        step_2_nome_socio: {required: setup.texts.testi['err_step_2_nome_socio'] },
	        step_2_website: {required: setup.texts.testi['err_step_2_website'] },
	        step_2_attivita_principale: {required: setup.texts.testi['err_step_2_attivita_principale'] },
	        step_2_p_iva: {required: setup.texts.testi['err_step_2_piva_o_step_2_cod_fis'] },
	        step_2_cod_fis: {required: setup.texts.testi['err_step_2_piva_o_step_2_cod_fis'], cfvalido : setup.texts.testi['err_step_2_cod_fis valido'] },
	        step_2_telefono: {required: setup.texts.testi['err_step_2_telefono'] },

	        step_3_nome: {required: setup.texts.testi['err_step_3_nome'] },
	        step_3_cognome: {required: setup.texts.testi['err_step_3_cognome'] },
	        step_3_ruolo: {required: setup.texts.testi['err_step_3_ruolo'] },
	        step_3_email: {required: setup.texts.testi['err_step_3_email'], email: setup.texts.testi['err_step_3_email_corretta'] },
	        step_3_telefono: {required: setup.texts.testi['err_step_3_telefono'] },
	        step_3_check_commercial: {required: setup.texts.testi['err_step_3_check_commercial'] },


	        step_4_nome: {required: setup.texts.testi['err_step_4_nome_o_usa_contatto_primario'] },
	        step_4_cognome: {required: setup.texts.testi['err_step_4_cognome_o_usa_contatto_primario'] },
	        step_4_ruolo: {required: setup.texts.testi['err_step_4_ruolo_o_usa_contatto_primario'] },
	        step_4_email: {required: setup.texts.testi['err_step_4_email_o_usa_contatto_primario'], email: setup.texts.testi['err_step_4_email_corretta'] },
	        step_4_telefono: {required: setup.texts.testi['err_step_4_telefono'] },
	        step_4_check_commercial: {required: setup.texts.testi['err_step_4_check_commercial'] },


	        step_5_nome: {required: setup.texts.testi['err_step_5_nome_o_usa_contatto_primario'] },
	        step_5_cognome: {required: setup.texts.testi['err_step_5_cognome_o_usa_contatto_primario'] },
	        step_5_ruolo: {required: setup.texts.testi['err_step_5_ruolo_o_usa_contatto_primario'] },
	        step_5_email: {required: setup.texts.testi['err_step_5_email_o_usa_contatto_primario'], email: setup.texts.testi['err_step_5_email_corretta'] },
	        step_5_telefono: {required: setup.texts.testi['err_step_5_telefono'] },
	        step_5_check_commercial: {required: setup.texts.testi['err_step_5_check_commercial'] },

	        step_6_presidente_check_commercial: {required: setup.texts.testi['err_step_6_presidente_check_commercial']},
					step_6_amministratore_delegato_check_commercial: {required: setup.texts.testi['err_step_6_amministratore_delegato_check_commercial']},
					step_6_direttore_generale_check_commercial: {required: setup.texts.testi['err_step_6_direttore_generale_check_commercial']},
					step_6_direttore_finanziario_check_commercial: {required: setup.texts.testi['err_step_6_direttore_finanziario_check_commercial']},
					step_6_direttore_risorse_umane_check_commercial: {required: setup.texts.testi['err_step_6_direttore_risorse_umane_check_commercial']},
					step_6_direttore_marketing_check_commercial: {required: setup.texts.testi['err_step_6_direttore_marketing_check_commercial']},
					step_6_direttore_relest_comunicazioni_check_commercial: {required: setup.texts.testi['err_step_6_direttore_relest_comunicazioni_check_commercial']},
					step_6_direttore_relist_publicaffair_check_commercial: {required: setup.texts.testi['err_step_6_direttore_relist_publicaffair_check_commercial']},
					step_6_partner_check_commercial: {required: setup.texts.testi['err_step_6_partner_check_commercial']},
					step_6_managing_partner_check_commercial: {required: setup.texts.testi['err_step_6_managing_partner_check_commercial']},
					step_6_associate_check_commercial: {required: setup.texts.testi['err_step_6_associate_check_commercial']},
					step_6_general_counsel_check_commercial: {required: setup.texts.testi['err_step_6_general_counsel_check_commercial']},

					step_7_motivo: {required: setup.texts.testi['err_step_7_motivo'] },
	        step_7_tramite: {required: setup.texts.testi['err_step_7_tramite'] },

	        step_8_nome: {required: setup.texts.testi['err_step_8_nome'] },
	        step_8_cognome: {required: setup.texts.testi['err_step_8_cognome'] },
	        step_8_ruolo: {required: setup.texts.testi['err_step_8_ruolo'] },
	        step_8_email: {required: setup.texts.testi['err_step_8_email'], email: setup.texts.testi['err_step_8_email_corretta'] },
	        step_8_telefono: {required: setup.texts.testi['err_step_8_telefono'] },
	        step_8_check_commercial: {required: setup.texts.testi['err_step_8_check_commercial'] },

	        step_9_check_privacy: {required: setup.texts.testi['err_step_9_check_privacy'] },
	        step_9_check_statuto: {required: setup.texts.testi['err_step_9_check_statuto'] },
	        
	      },
	      invalidHandler: function() {
	      },
	      showErrors: function(errorMap, errorList) {
		        $("#form-associarsi").find("input").each(function() {
		            $(this).removeClass("error");
		        });
		        if(errorList.length) {
		            var tmpl = '<span class="glyphicon glyphicon-remove-circle" style="font-size: 70px; color:orange;"></span><br><br>' +
				        '<h4>' + errorList[0]['message'] + '</h4><br>';
				        attivaModal(tmpl, ['Chiudi'], ['']);
		            $(errorList[0]['element']).addClass("error");
		        }
		    }
	    });

  		

	  	if (validatorStep.form()) {
	  		
	  		var arr = {};

	      var stepContent = '#step-'+step;
	      $('input', stepContent).each(function(i){
	      	arr[$(this).attr('name')] = $(this).val();

	      	if ($(this).is(':radio')) {
	      		arr[$(this).attr('name')] = $('input[name=' + $(this).attr('name') + ']:checked').val();
	      	}
	      	if ($(this).is(':checkbox')) {
	      		arr[$(this).attr('name')] = $(this).is(':checked');
	      	}
	    	});
	    	

	    	$('textarea', stepContent).each(function(i){
	      	arr[$(this).attr('name')] = $(this).val();
	    	});
	    	$('select', stepContent).each(function(i){
	      	arr[$(this).attr('name')] = $(this).val();
	    	});

	    	arr.idpagina = $('#idpagina').val();
      	arr.pagina = $('#pagina').val();

	      var jsonString = JSON.stringify(arr);

		      var fd = new FormData();
		      fd.append('action', 'set-riepilogo');
		      fd.append('step', step);
		      fd.append('obj', jsonString);

			  	$.ajax({
	          url: '/ajax/riepilogo_new.php',
	          method: 'POST',
	          contentType: false,
	          processData: false,
	          data: fd,
	          success: function(ret) {

	          	if (step == 9) {

	          		var tmpl = '<span class="glyphicon glyphicon-time" style="font-size: 70px; color:orange;"></span><br><br>' +
				        '<h4>Stiamo inoltrando la sua richiesta, attendere un attimo...</h4><br><br>';
				        attivaModal(tmpl, null, null);	

					  		arr.email = $('#step_8_email').val();
				      	arr.nome = $('#step_8_nome').val();
				      	arr.cognome = $('#step_8_cognome').val();
				      	arr.richiesta = ret;

				      	var jsonString = JSON.stringify(arr);

					  		var fd = new FormData();
					      fd.append('action', 'invia-richiesta-associazione');
					      fd.append('obj', jsonString);

						  	$.ajax({
				          url: '/ajax/functions.php',
				          method: 'POST',
				          contentType: false,
				          processData: false,
				          data: fd,
				          success: function(ret) {
				          	var arr = ret.split('|');
				            var tmpl = '';

				            if (arr[0] === '1') {

				            //	ga('send', {
				            //    hitType: 'event',
				            //    eventCategory: 'Contact',
				            //    eventAction: 'send-email',
				            //    eventLabel: 'compilazione form associati'
				            //  });

				          		document.location.href = window.stepGrazie;
				          	}else {
				              tmpl = '<span class="glyphicon glyphicon-remove-sign" style="font-size: 70px; color:orange;"></span><br><br><h4>' + arr[1] + '</h4><br><br>';
				            	attivaModal(tmpl, ['Chiudi'], [''], null);
				            }
				          }
				        });

					  	} else {

					  		if (ret == 'error') {
					  			tmpl = '<span class="glyphicon glyphicon-remove-sign" style="font-size: 70px; color:orange;"></span><br><br><h4>Si è verificato un problema durante la compilazione del form, si prega di ripetere la procedura. In caso il problema continui a verificarsi la preghiamo di contattare direttamente il nostro staff per gestire al meglio la situazione. Grazie mille.</h4><br><br>';
				          attivaModal(tmpl, ['Chiudi'], [''], null);
				          $('#riepilogo').html(tmpl);
					  		} else {
			          	$('#riepilogo').html(ret);
			          	$('.step').hide();
				  				$(next).show();
					  		}
					  	}


	          }
	        });
		  	



		  }
	  };

	  var getRiepilogo = function() {

      var fd = new FormData();
      fd.append('action', 'get-riepilogo');
      
	  	$.ajax({
          url: '/ajax/riepilogo_new.php',
          method: 'POST',
          contentType: false,
          processData: false,
          data: fd,
          success: function(ret) {
	  				$('#riepilogo').html(ret);
          }
      });


	  };


	  $('.btn_next').on('click', function(){
	  	var step = $(this).data('step');
	  	var next = '#'+$(this).data('next');
	  	//console.log(next);
			setRiepilogo(step, next);
			
			$("html, body").animate({ scrollTop: $('#toppage').offset().top }, 100);

			

		return false;
	  });

	  $('.btn_back').on('click', function(){
	  	var step = '#'+$(this).data('back');
	  	//console.log(step);
	  	$('.step').hide();

	  	getRiepilogo();
			
	  	
	  	$(step).show();
			$("html, body").animate({ scrollTop: $('#toppage').offset().top }, 100);


		return false;
	  });

	});

}(jQuery));